const { prop } = require('ramda');

module.exports = value => {
  const allocatedCount = prop('allocatedCount')(value);
  const pendingRequestCount = prop('pendingRequestCount')(value);
  const assignedCount = prop('assignedCount')(value);

  if (!allocatedCount && !pendingRequestCount) {
    return '';
  } else {
    return `${assignedCount} of ${allocatedCount}`;
  }
};
